
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/lists",
      function () {
        return require("private-next-pages/account/lists.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/lists"])
      });
    }
  